module.exports = __webpack_public_path__ + "static/img/1.bda7055.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/4/zh/1.png
// module id = +wiF
// module chunks = 0